angular.module('zc.zenclerkS')
  .component('zcsMain', {
    templateUrl: '/templates/zenclerk_s/layout/main.html',
    controllerAs: 'vm',
    controller: zcsMain,
  });

function zcsMain() {
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/main.js